import invert from 'lodash/invert';

import Logger from '../tools/Logger';

/*
 * musicId is NOT provided by Catalog, but can be derived from pandoraId.
 * Translating pandoraId <-> musicId is DISCOURAGED.
 * As legacy APIs (login, getStations, etc) are updated to provide pandoraId usage of this lib will be removed
 */

const log = Logger.child({ component: 'PandoraIdUtil' });

const THUMBPRINT_RADIO_PREFIX = 'TT';

const TYPE_TO_MUSICID_TYPE = {
  AR: 'R',
  AL: 'L',
  TR: 'S',
  CO: 'C',
  GE: 'G',
  WO: 'W',
  TT: THUMBPRINT_RADIO_PREFIX,
} as const;

const TYPE_TO_PANDORAID_TYPE = invert(TYPE_TO_MUSICID_TYPE);

export function getMusicIdFromPandoraId(pandoraId: string): string | undefined {
  const [pandoraIdType = '', id = ''] = pandoraId.split(':');

  if (!(pandoraIdType in TYPE_TO_MUSICID_TYPE)) {
    log.warn(`getMusicIdFromPandoraId failed to translate id for ${pandoraId}`);
    return;
  }
  return `${TYPE_TO_MUSICID_TYPE[pandoraIdType as keyof typeof TYPE_TO_MUSICID_TYPE]}${id}`;
}

export function getPandoraIdFromMusicId(musicId: $TSFixMe): string | undefined {
  if (musicId.indexOf(THUMBPRINT_RADIO_PREFIX) === 0) {
    return `${THUMBPRINT_RADIO_PREFIX}:${musicId.substr(2)}`;
  }

  const prefix = musicId.substr(0, 1);
  const id = musicId.substr(1);

  if (!TYPE_TO_PANDORAID_TYPE[prefix]) {
    log.warn(`getPandoraIdFromMusicId failed to translate id for ${musicId}`);
    return;
  }
  return `${TYPE_TO_PANDORAID_TYPE[prefix]}:${id}`;
}
